<script>
    import {_, locale, number} from 'svelte-i18n';
    import Item from './Item.svelte';
    import {gameConfig} from "../../stores.js";
    import {selectedCurrency} from "../../stores.js";

    let { item, gameItem } = $props();
    let itemDetails = $state({});

    function setItemDetails() {
        itemDetails.title = $_("GameTokenTitle", {
            values: {
                AMOUNT: $number(gameItem.price / 100, {
                    style: 'currency',
                    currency: 'USD',
                })
            }
        });
        itemDetails.description = $_("GameTokenDescription");
        itemDetails.amount = item.amount;
        itemDetails.icon = "packGameToken";
        itemDetails.rarity = gameItem.rarity;
        itemDetails.expireAt = $gameConfig?.temporaryItems?.[item.id];
        itemDetails.claimed = item.claimed;
    }

    $effect(() => {
        $locale;
        setItemDetails();
    });
</script>

<Item {itemDetails}/>
